import { useQuery } from 'react-query';
import { EventParticipationAPI } from 'api/eventParticipation';
import { EVENT_PARTICIPATION } from 'helpers/constants';

export default function useEventParticipationForMyResults(competitionId) {
  return useQuery(
    [EVENT_PARTICIPATION, 'my-results', competitionId],
    () => EventParticipationAPI.getAllForMyResults(competitionId),
    {
      enabled: !!competitionId,
    }
  );
}
